import Vue from "Vue";
import { Component, Prop, Watch } from 'vue-property-decorator';
import moment from 'moment';

@Component
export default class InputTime extends Vue {
    @Prop()
    private vmodel;

    @Prop({ default: "" })
    public label;

    @Prop({ default: false })
    private disabled;

    @Prop({ default: false })
    private required;

    @Prop({ default: true })
    private show;

    @Prop({ default: false })
    private error;

    @Prop({ default: false })
    private isBackgroundGrey;

    public value;

    constructor() {
        super();
        this.value = "";
    }

    @Watch('vmodel', { immediate: true })
    private setValue(): void {
        // Si la valeur est vide ou null, on affiche une valeur vide (affichage : "--:--")
        if (this.vmodel == null || this.vmodel == "") {
            this.value = "";
        } else {
            // Sinon, on affiche la valeur sous forme de date et on la formate en HH:mm
            var dateVmodel = new Date(this.vmodel);
            this.value = moment(new Date(Date.UTC(dateVmodel.getUTCFullYear(), dateVmodel.getUTCMonth(), dateVmodel.getUTCDate(), dateVmodel.getUTCHours(), dateVmodel.getUTCMinutes()))).format("HH:mm");
        }
    }

    public focus(e): void {
        e.target.select();
    }

    public blur(e): void {
        const raw = (e.target as HTMLInputElement).value;
        // Si la valeur est vide ou null, on envoie null à la vmodel et on émet l'événement changed
        if (raw === "" || raw == null) {
            this.$emit("update:vmodel", null);
            this.$emit("changed");
            return;
        }
        var date = new Date("2022-01-01" + ' ' + e.target.value);
        var dateMoment = moment(new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate(), date.getUTCHours(), date.getUTCMinutes())));
        this.$emit('update:vmodel', dateMoment.format("YYYY-MM-DDTHH:mm:ss"));
        this.$emit('changed');
    }

    public paste(e): void {
        e.preventDefault();
    }
}



// WEBPACK FOOTER //
// ./src/shared/components/InputTime/InputTime.ts